import { ChangeDetectorRef, Component, HostListener, OnInit, TemplateRef, ViewChild, ElementRef } from '@angular/core';
import { AssetsService } from "../../core/services/assets.service";
import { UserService } from "src/app/core/services/user.service";
import { Router, ActivatedRoute } from '@angular/router';
import { CatlougeTypeConstants } from "src/app/core/constants";
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { PlayListService } from "src/app/views/playlist/playlist/playlist.service";
import { ToastrService } from 'ngx-toastr';
import { Meta, Title } from '@angular/platform-browser';
import { CommonService } from "src/app/core/services/common.service";
import { PageTitleService } from 'src/app/services/title/page-title.service';
import { EventTrackingService } from 'src/app/services/google/event-tracking.service';
import { SpinnerVisibilityService } from 'ng-http-loader';
import { jwPlayerService } from '../jw-video-player/jwplayer.servies';
import { customOptionsForSevenMiniSlider, episodeDetailSampleData, recommendedSampleDataForLive, recommendedSampleDataNotLive } from "src/app/shared/owl-slider-config";
import { fromEvent } from 'rxjs';

import { HttpClient } from '@angular/common/http';
import { DeviceDetectorService } from 'ngx-device-detector';
declare var $: any;


import * as CryptoJS from 'crypto-js';
declare var videojs;
declare var google;
//@HostListener('window:popstate', ['$event'])

@Component({
  selector: 'app-detail-episode',
  templateUrl: './detail-episode.component.html',
  styleUrls: ['./detail-episode.component.css'],
  providers: [PageTitleService, PlayListService]
})

export class DetailEpisodeComponent implements OnInit {
  @ViewChild('deviceNotAllowed') deviceNotAllowed;
  seasonForm: FormGroup;
  moviesPageAssetsStatus: boolean;
  episodeDeatil: any;
  allEpisode: any;
  catlouge = CatlougeTypeConstants.catlogue;
  recommendedData: any;
  playermodal: any;
  tempQueryStr: any = {};
  episodeArr: any = [];
  episodeArrOnChange: any[] = [];
  deafultEpisodeName: any;
  firstSelectedEpisode: any;
  readMoreText: string = 'View More';
  tempSynapsi = `There are many variations of passages of Lorem Ipsum available, but the majority have suffered alteration in some form, by injected humour, or randomised words which don't look even slightly believable. If you are going to use a passage of Lorem Ipsum, you need to be sure there isn't anything embarrassing hidden in the middle of text. All the Lorem Ipsum generators on the Internet tend to repeat predefined chunks as necessary, making this the first true generator on the Internet. It uses a dictionary of over 200 Latin words, combined with a handful of model sentence structures, to generate Lorem Ipsum which looks reasonable. The generated Lorem Ipsum is therefore always free from repetition, injected humour, or non-characteristic words etc.`
  readmoreCond: boolean = false;
  currentSeaon: any;
  seasonIndex: number = 0;
  userInfo: any;
  playList: any;
  setWatchLitemItem: any;
  episodeMoreCond: any = false;
  @ViewChild('closeAddtoWatchListModal') closeAddtoWatchListModal;
  @ViewChild('addToWatchListSuccessFromDetail') addToWatchListSuccessFromDetail;
  @ViewChild('removeToWatchListSuccessModal') removeToWatchListSuccessModal;
  @ViewChild('play_preview') previewRef: TemplateRef<any>;
  playListId: string;
  stopPosition: string;
  addWachlistItemFromDetail: any;
  error_code: any;
  episodeIndex: any;
  loading: boolean = false;
  playEpisodeData: any;

  playerSubscriber: any = '';
  customOptionsForSevenMiniSlider = customOptionsForSevenMiniSlider;
  addedAssetIndexFromRecommended: any;
  homePageAssets: any;
  playlist: any;
  playListAvailable: boolean;
  deletedItem: any;
  routeName: string;
  deleteAsset_id: any;
  deleteFrom: string;
  progressInc: number = 0;
  progrssBarValue: number = 0;
  copyLink: boolean = false;
  seasonData: any;
  seasonList: any;
  showError: boolean = false;
  preview_active: boolean = false;
  playUrlResObj: any;
  currentPlayingCode: string = "";
  is_preview: boolean = true;

  is_muted: boolean = true;
  is_event_started: boolean = true; //  for event live now
  is_event_streamed: boolean = false; // for event end
  ipAddress: any;
  sessionId: any;

  page: number = 1;
  isScroll: boolean = false;


  plainText: string = 'hello';
  encryptText: string = 'U2FsdGVkX1+mClD8siYGucUR2TVECvnXiGGUIjCHYYk=';
  encPassword: string = '1234';
  decPassword: string = '1234';
  conversionEncryptOutput: string;
  conversionDecryptOutput: string;

  data = "Example1";//Message to Encrypt
  iv = CryptoJS.enc.Base64.parse("");//giving empty initialization vector
  key = CryptoJS.SHA256("Message");//hashing the key using SHA256
  encrypted_UUID: any;

  deviceInfo = null;
  totalSeason: any;

  isCloudFrontType: boolean = true;
  notFoundImg: any;
  isPlan: any;
  deviceMsg: any;
  @ViewChild('openLoginModel') openLoginModel: ElementRef;

  constructor(
    public AssetsService: AssetsService,
    public UserService: UserService,
    public router: Router,
    public activatedRoute: ActivatedRoute,
    private modalService: NgbModal,
    private formBuilder: FormBuilder,
    public playListService: PlayListService,
    public toastr: ToastrService,
    private meta: Meta,
    public commonService: CommonService,
    public pageTitleService: PageTitleService,
    private googleEventTracking: EventTrackingService,
    public spinner: SpinnerVisibilityService,
    public jwservice: jwPlayerService,
    private googleEvent: EventTrackingService,
    private cdref: ChangeDetectorRef,
    public actionBarTitle: Title,
    private http: HttpClient,
    private deviceService: DeviceDetectorService
  ) {


    document.body.scrollTop = 0;
    this.episodeDeatil = episodeDetailSampleData.result;
    this.stopPosition = localStorage.getItem('stop');
    this.activatedRoute.params.subscribe(params => {
    });
    this.playerSubscriber = this.jwservice.closePlayerEvent.subscribe((isClosed) => {
      console.log('isClosed');
      if (isClosed) {
        this.preview_active = true;
        this.enableScrollBar();
        this.getAssetsData();
        this.jwservice.closePlayer.next(false);
      }
    });
    this.activatedRoute.params.subscribe(params => {
      console.log('type=' + params['type'])
      this.episodeDeatil.type = params['type'];
    });

  }

  contentCopied(e) {
    this.copyLink = e.isSuccess;
  }

  ngAfterContentChecked() {
    this.cdref.detectChanges();
  }

  ngOnDestroy() {

    this.playerSubscriber.unsubscribe();
    // this.getAssetsData();
    this.readmoreCond = false;
    this.readMoreText = 'View More';
    this.checkOldPlayer();


  }

  ngAfterViewInit() {
    if (!(localStorage.getItem('userInfo'))) {
      //this.router.navigate(['/'])
      this.openLoginModel.nativeElement.click();
    }
}
 

  ngOnInit(): void {
    this.notFoundImg = "landscape";
    if (this.commonService.filterType == 1) {
      this.isCloudFrontType = true;
    } else {
      this.isCloudFrontType = false;
    }



    this.readmoreCond = false;
    this.readMoreText = 'View More'
    // this.pageTitleService.setTitle('Detail');
    document.body.scrollTop = 0;
    this.activatedRoute.params.subscribe(params => {

      let tempObj = { type: '' };



      if (params['type'] == 'video') {
        tempObj['type'] = 'vod';
      }
      else {
        tempObj['type'] = params.type;
      }

      if (params['type'] == 'episode' || params['type'] == 'tvshow') {
        tempObj['type'] = 'tvshow';
      }

      this.tempQueryStr = { ...params, ...tempObj };

      // debugger;

      this.getAssetsData()
      let userMenuName;
      if (this.tempQueryStr.type == 'vod') {
        userMenuName = 'home';
      }
      if (this.tempQueryStr.type == 'movie') {
        userMenuName = 'movies';
      }
      if (this.tempQueryStr.type == 'livetv') {
        userMenuName = 'livetv';
      }

      if (this.tempQueryStr.type == 'episode') {
        userMenuName = 'tvshows';
      }

      if (userMenuName == 'livetv') {
        this.notFoundImg = "square";
        this.recommendedData = recommendedSampleDataForLive;
        // this.episodeDeatil.type = 'livetv';
      } else {
        this.recommendedData = recommendedSampleDataNotLive;

      }
      this.UserService.updateSelectedMenu(userMenuName);
    });
    console.log(this.episodeDeatil.type);
    this.liniarProgressBar();


    this.userInfo = JSON.parse(localStorage.getItem('userInfo'));
    // if (!(localStorage.getItem('userInfo'))) {
    //   this.router.navigate(['/'])
    // }

    if (this.userInfo) {
      // params.get('productId')
      this.playListId = localStorage.getItem('playListId');

    }

    // this.meta.addTags([
    //   { name: 'twitter:site', content: '@alligatorio' },
    //   { name: 'twitter:site', content: '@alligatorio' }
    // ], true);

    // const viewport = this.meta.getTag('name=viewport');
    // console.log(viewport)
    // this.getDeviceInfo();
    // this.getIPAddress();



  }

  openLoginModal(content) {
    this.modalService.open(content, { ariaLabelledBy: 'modal-basic-title', backdrop: false, windowClass: 'detailPageLogin'}).result.then((result) => {
    }, (reason) => {
    });

  }

  
  getDeviceInfo() {
    console.log('hello `Home` component');
    this.deviceInfo = this.deviceService.getDeviceInfo();
    const isMobile = this.deviceService.isMobile();
    const isTablet = this.deviceService.isTablet();
    const isDesktopDevice = this.deviceService.isDesktop();
    console.log(this.deviceInfo);
    console.log(isMobile);  // returns if the device is a mobile device (android / iPhone / windows-phone etc)
    console.log(isTablet);  // returns if the device us a tablet (iPad etc)
    console.log(isDesktopDevice); // returns if the app is running on a Desktop browser.
  }





  encryptData(data, iv, key) {

    if (typeof data == "string") {
      data = data.slice();
      this.encrypted_UUID = CryptoJS.AES.encrypt(data, key, {
        iv: iv,
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7
      });
    }
    else {
      this.encrypted_UUID = CryptoJS.AES.encrypt(JSON.stringify(data), key, {
        iv: iv,
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7
      });
    }
    return this.encrypted_UUID.toString();
  }
  decryptData(encrypted, iv, key) {
    var decrypted = CryptoJS.AES.decrypt(encrypted, key, {
      iv: iv,
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7
    });
    return decrypted.toString(CryptoJS.enc.Utf8)
  }

  getIPAddress() {
    this.http.get("http://api.ipify.org/?format=json").subscribe((res: any) => {
      this.ipAddress = res.ip;
      this.sessionId = localStorage.getItem("sessionId");
      // this.plainText = this.sessionId+ '-'+ this.ipAddress;

      this.data = this.sessionId + '-' + this.ipAddress + '-' + this.deviceInfo.os_version;
      console.log('ipAddress', this.ipAddress);
      console.log('sessionId', this.sessionId);
      console.log('this.data', this.data);

      this.encrypted_UUID = this.encryptData(this.data, this.iv, this.key);
      console.log(this.encrypted_UUID);//genrated encryption String:  swBX2r1Av2tKpdN7CYisMg==

      var decrypteddata = this.decryptData(this.encrypted_UUID, this.iv, this.key);
      console.log(decrypteddata);//genrated decryption string:  Example1
    });
  }

  shareTB() {
    var twitterUrl = `https://twitter.com/intent/tweet?text=${this.episodeDeatil['name']}&url=${encodeURIComponent(this.episodeDeatil['share_url'])}`;

    var twitterWindow = window.open(twitterUrl,
      'twitter-popup',
      'height=350,width=600'
    );

    if (twitterWindow.focus) {
      twitterWindow.focus();
      if (Object.keys(this.userInfo.result).length > 0) {

        let userUnique = '';
        if (this.userInfo.result.register_by == "mobile") {
          userUnique = this.userInfo.result.mobile;
        } else {
          userUnique = this.userInfo.result.emailaddress;
        }

        this.googleEvent.eventEmitter('twitter', 'Share', userUnique + '-' + this.episodeDeatil['code'] + '-' + this.episodeDeatil['name'], 0, userUnique, userUnique + '-' + this.episodeDeatil['code'] + '-' + this.episodeDeatil['name']);
      }
    }
    return false;
  }

  shareFB() {
    var fbShareLink = encodeURIComponent(this.episodeDeatil['share_url']);
    var facebookWindow = window.open(
      'https://www.facebook.com/sharer/sharer.php?u=' + fbShareLink,
      'facebook-popup',
      'height=350,width=600'
    );
    if (facebookWindow.focus) {
      facebookWindow.focus();
      if (Object.keys(this.userInfo.result).length > 0) {

        let userUnique = '';
        if (this.userInfo.result.register_by == "mobile") {
          userUnique = this.userInfo.result.mobile;
        } else {
          userUnique = this.userInfo.result.emailaddress;
        }

        this.googleEvent.eventEmitter('fb Share', 'Share', userUnique + '-' + this.episodeDeatil['code'] + '-' + this.episodeDeatil['name'], 0, userUnique, userUnique + '-' + this.episodeDeatil['code'] + '-' + this.episodeDeatil['name']);
      }
    }
    return false;
  }


  openMailBody() {

    let emailSubject = this.episodeDeatil['name'];
    let emailBody = encodeURIComponent(this.episodeDeatil['share_url']);
    var mail = `mailto:?subject=${emailSubject}&body=${emailBody} \n`;
    window.open(mail);
  }


  getAssetsData() {
  

    if (this.tempQueryStr.type == 'episode' || this.tempQueryStr.type == 'tvshow') {
      this.getSeasonsData();
    }
    this.seasonData;
    console.log('getAssetsData');
    let assetDetail = {
      "code": this.tempQueryStr.code,
      "catlogue": this.catlouge,
      "platform": 'web',
      "type": this.tempQueryStr.type ? this.tempQueryStr.type : ''
    }
    let urlEncodedDetail = this.UserService.convertoJSONToUrlEncoded(assetDetail);
    setTimeout(() => {

      this.AssetsService.getAssetDetail(urlEncodedDetail).subscribe(data => {
        //console.log(data.result);
        if (data && data.result) {

          if (data.error_code === 401) {
            window.location.replace('404')
          }

          if (Object.keys(data.result).length === 0) {
            document.getElementById("nexg_ngb-progressbar").style.display = 'none';
            document.getElementById('maincontentarea').classList.remove("_beforeLoad");
            this.showError = true;
          }
          else {


            this.episodeDeatil = data.result;
            this.isPlan = data.plan;
            this.episodeDeatil['plan'] = data.plan;
            var ts = Math.round((new Date()).getTime() / 1000);
            console.log('tssss', this.episodeDeatil);
            console.log('event_start_time', parseInt(this.episodeDeatil.event_start_time));
            console.log('event_end_time', parseInt(this.episodeDeatil.event_end_time));

            if (ts >= this.episodeDeatil.event_start_time
              && ts <= this.episodeDeatil.event_end_time) {
              console.log('watch live');
              this.is_event_started = true;

            } else {
              console.log('not live');
              this.is_event_started = false;
            }
            if (this.episodeDeatil.type == 'event' && ts > this.episodeDeatil.event_end_time) {
              console.log('streamed');
              this.is_event_streamed = true;
            }

          }

          this.episodeDeatil['type'] = this.episodeDeatil.type ? this.episodeDeatil.type : this.tempQueryStr.type
          if (this.episodeDeatil.recently_watched) {
            this.episodeDeatil['stop'] = this.episodeDeatil.recently_watched.stop;

          }
          console.log(this.episodeDeatil['stop']);
          if (this.isCloudFrontType == true) {
            var bgImage = this.tempQueryStr.type == 'episode' ? this.episodeDeatil.image_cloudfront_url : this.tempQueryStr.type == 'livetv' ? this.episodeDeatil.chimage_cloudfront_url : this.episodeDeatil.image_cloudfront_url;
          } else {
            var bgImage = this.tempQueryStr.type == 'episode' ? this.episodeDeatil.image : this.tempQueryStr.type == 'livetv' ? this.episodeDeatil.chimage : this.episodeDeatil.image;
          }

          if (this.episodeDeatil.name != undefined)
            this.pageTitleService.setTitle("Platform8 | " + this.episodeDeatil.name);
          else
            this.pageTitleService.setTitle(this.episodeDeatil.channel_name);


          this.googleEventTracking.routeTrack(this.commonService.detailRoute(this.episodeDeatil));

          if (this.tempQueryStr.type == 'tvshow' || this.tempQueryStr.type == 'episode') {
            this.episodeDeatil.image = bgImage;
            this.episodeDeatil['totalSeason'] = Object.keys(this.totalSeason).length;
          }
          setTimeout(() => {
            try {
              console.log(this.episodeDeatil);
              try {
                // if (this.episodeDeatil.recently_watched.season && this.episodeDeatil.recently_watched.season.season_number && this.episodeDeatil.recently_watched.no) {
                //   this.changeSeason(this.episodeDeatil.recently_watched.season.season_number, (this.episodeDeatil.recently_watched.season.season_number));
                // }
              } catch (e) {
                console.log(e);
              }
              bgImage = this.commonService.compressImgUrl2(bgImage, { 'width': 1280, 'height': 720 }, "landscape");
              document.getElementById('detail_banner').style.backgroundImage = "url(" + bgImage + ")";
              document.getElementById("nexg_ngb-progressbar").style.display = 'none';
              document.getElementById('maincontentarea').classList.remove("_beforeLoad");
            }
            catch (e) {
              console.log(e)
            }

          }, 200)

          // recommended Section 
          let recommededParams = {
            code: this.episodeDeatil.type == 'livetv' ? this.episodeDeatil.code : this.episodeDeatil.recently_watched.code,
            search_text: '',
            catlogue: this.catlouge
          }
          this.recomData(recommededParams);


        }
        if (this.episodeDeatil.preview && this.episodeDeatil.preview.length > 0 && !this.preview_active) {

          this.playMoviePreview(this.episodeDeatil, this.previewRef);

        } else {
          var oldPlayer = document.getElementById('preview_video');
          // remove player
          if (oldPlayer) {
            videojs(oldPlayer).dispose();
          }
        }

      });
    }, 2000)




  }



  // getSeasonsData() {

  //   let assetDetail = {
  //     "code": this.tempQueryStr.code,
  //     "catlogue": this.catlouge,
  //     "platform": 'web',
  //     "type": 'seasons'
  //   }
  //   let urlEncodedDetail = this.UserService.convertoJSONToUrlEncoded(assetDetail);
  //   // setTimeout(() => {

  //   this.AssetsService.getAssetDetail(urlEncodedDetail).subscribe(data => {
  //     //console.log(data.result);
  //     if (data && data.result) {
  //       if (data.error_code === 401) {
  //         window.location.replace('404')
  //       }
  //       this.seasonData = data;
  //       if (this.episodeDeatil.recently_watched && this.episodeDeatil.recently_watched.season) {
  //         this.changeSeason(this.episodeDeatil.recently_watched.season.season_number, (this.episodeDeatil.recently_watched.season.season_number));
  //       }


  //     }

  //   });
  //   // }, 2000)

  // }

  // changeSeason(index, seasonName) {
  //   this.seasonIndex = this.seasonData.result.findIndex(season => season.season_number == seasonName)
  //   this.currentSeaon = 'Season ' + (index ? index : 1);
  // }



  getSeasonsData() {
    this.page = 1;
    let assetDetail = {
      "code": this.tempQueryStr.code,
      "catlogue": this.catlouge,
      "platform": 'web',
      "type": 'tvshow_order'
    }
    let urlEncodedDetail = this.UserService.convertoJSONToUrlEncoded(assetDetail);

    this.AssetsService.getAssetDetail(urlEncodedDetail).subscribe(data => {

      if (data && data.result) {

        if (data.error_code === 401) {
          window.location.replace('404')
        }
        this.seasonData = data;

        this.totalSeason = data.result.season;

        if (this.seasonData.result.recently_watched && this.seasonData.result.recently_watched.season) {
          let seaDetail = {
            "code": this.tempQueryStr.code,
            "catlogue": this.catlouge,
            "platform": 'web',
            "season_id": this.seasonData.result.recently_watched.season_id,
            "type": 'seasons_order'
          }
          let urlEncodeSeadDetail = this.UserService.convertoJSONToUrlEncoded(seaDetail);
          this.AssetsService.getAssetDetail(urlEncodeSeadDetail).subscribe(episodeData => {
            this.allEpisode = episodeData;
          });

          this.changeSeasonIndex(this.seasonData.result.recently_watched.season.season_number, (this.seasonData.result.recently_watched.season.season_number));
        }
      }

    });

  }


  changeSeason(seasonId, seasonNumber, seasonName) {
    this.page = 1;
    let seaDetail = {
      "code": this.tempQueryStr.code,
      "catlogue": this.catlouge,
      "platform": 'web',
      "season_id": seasonId,
      "type": 'seasons_order'
    }
    let urlEncodeSeadDetail = this.UserService.convertoJSONToUrlEncoded(seaDetail);
    this.AssetsService.getAssetDetail(urlEncodeSeadDetail).subscribe(episodeData => {
      this.allEpisode = episodeData;
    });
    this.changeSeasonIndex(seasonNumber, seasonName);
  }

  changeSeasonIndex(index, seasonName) {
    this.seasonIndex = this.seasonData.result.season.findIndex(sea => sea.season_number == seasonName)
    this.currentSeaon = 'Season ' + (index ? index : 1);
  }

  @HostListener("window:scroll", [])
  onScroll() {
    let maxPage = this.seasonData && this.seasonData.result && this.seasonData.result.season[this.seasonIndex] ? parseInt(this.seasonData.result.season[this.seasonIndex].total_pages) : 0;

    if ((window.innerHeight + window.scrollY) >= document.body.offsetHeight * .7 && this.isScroll == false) {
      if (maxPage >= this.page) {
        this.page++;
        this.isScroll = true;
        let seaDetail = {
          "code": this.tempQueryStr.code,
          "catlogue": this.catlouge,
          "platform": 'web',
          "season_id": this.seasonData.result.season[this.seasonIndex].season_id,
          "page": this.page,
          "type": 'seasons_order'
        }
        let urlEncodeSeadDetail = this.UserService.convertoJSONToUrlEncoded(seaDetail);
        try {
          setTimeout(() => {
            this.AssetsService.getAssetDetail(urlEncodeSeadDetail).subscribe(episodeData => {
              this.isScroll = false;
              let getLastdata = episodeData.result[0].assets;
              let preData = this.allEpisode.result[0].assets;
              this.allEpisode.result[0].assets = [...preData, ...getLastdata];

            });
          }, 1000);
        } catch (err) {
          alert(JSON.stringify(err));
        }

      }
    }
  }
  public onModalClosed(data: any): void {
    console.log('Picked date: ', data);
    this.deviceMsg = data;
    this.deviceNotAllowed.nativeElement.click();
  }



  playvideo(data, content) {
    localStorage.setItem('is_check_device', 'true'); // set parmeter for call device api run or not
    if (this.episodeDeatil.type == 'tvshow' || this.episodeDeatil.type == 'episode') {
      this.episodeDeatil['type'] = 'episode';
      // this.episodeDeatil['seasons'] = this.seasonData.result;
    }

    data.is_trailer = 0;
    data.is_liveEvenet = 0;
    console.log(content);
    this.checkOldPlayer();
    this.disableScrollBar();
    try {
      this.modalService.open(content, { ariaLabelledBy: 'modal-basic-title', windowClass: '_play_modal_jw jwfullscreen', backdrop: 'static', keyboard: false }).result.then((result) => {
      }, (reason) => { });
    } catch (e) {
      console.log(e);
    }
    if (this.episodeDeatil.type == 'event') {
      data.is_liveEvenet = 1;
      let userUnique = '';
      if (this.userInfo.result.register_by == "mobile") {
        userUnique = this.userInfo.result.mobile;
      }
      else {
        userUnique = this.userInfo.result.emailaddress;
      }
      this.googleEvent.eventEmitter('Video_View', 'Video_View', data.name + '-' + data.code + '-' + userUnique, 0, userUnique, data.name + '-' + data.code + '-' + userUnique);
    }


  }

  playvideoFromStart: any = [];

  playvideoFromStarts(data, content, paidOrFree) {
    localStorage.setItem('is_check_device', 'true');

    if (this.episodeDeatil.type == 'event') {
      data.is_liveEvenet = 1;
      let userUnique = '';
      if (this.userInfo.result.register_by == "mobile") {
        userUnique = this.userInfo.result.mobile;
      }
      else {
        userUnique = this.userInfo.result.emailaddress;
      }
      this.googleEvent.eventEmitter('Video_View', 'Video_View', data.name + '-' + data.code + '-' + userUnique, 0, userUnique, data.name + '-' + data.code + '-' + userUnique);
    }

    if (!paidOrFree) {
      return false;
    }
    this.checkOldPlayer();
    // content.start = 0;
    this.disableScrollBar()

    this.playvideoFromStart = data;
    if (data.type == 'tvshow' || data.type == 'episode') {
      this.playvideoFromStart.type = 'episode';
    }
    this.playvideoFromStart['recently_watched'].stop = 0;
    this.modalService.open(content, { ariaLabelledBy: 'modal-basic-title', windowClass: '_play_modal_jw jwfullscreen', backdrop: 'static', keyboard: false }).result.then((result) => {

    }, (reason) => {

    });



  }
  playTrailer: any = [];
  playMovieTrailer(data, content) {
    localStorage.setItem('is_check_device', 'false');
    // this.playermodal.player.reset();
    this.checkOldPlayer();
    // content.start = 0;s
    this.disableScrollBar();
    data.is_trailer = 1;
    this.playTrailer = data;


    // this.playTrailer['recently_watched'].stop = 0;
    this.modalService.open(content, { ariaLabelledBy: 'modal-basic-title', windowClass: '_play_modal_jw jwfullscreen', backdrop: 'static', keyboard: false }).result.then((result) => {
    }, (reason) => {

    });

    let userUnique = '';
    if (this.userInfo.result.register_by == "mobile") {
      userUnique = this.userInfo.result.mobile;
    }
    else {
      userUnique = this.userInfo.result.emailaddress;
    }

    this.googleEvent.eventEmitter('Trailer', 'video_View', data.name + '-' + data.code + '-' + userUnique, 0, userUnique, data.name + '-' + data.code + '-' + userUnique);

  }
  checkOldPlayer() {
    var oldPlayer = document.getElementById('preview_video');

    if (oldPlayer) {
      this.is_preview = false;
      videojs(oldPlayer).dispose();
    }
  }
  playPreview: any = [];
  playMoviePreview(data, content) {
    localStorage.setItem('is_check_device', 'false');

    if (!data.preview[0].preview_url) {
      this.is_preview = false;
      return;
    }

    this.is_preview = true;
    let noerror = 1;
    let watch_credit_status = 1;

    let playObj = data.preview[0];
    this.playUrlResObj = data.preview[0];
    console.log(this.playUrlResObj);

    //let videoPlayUrl = playObj.preview_url;


    let videoPlayUrl: any;
    if (
      data.cloud_front &&
      Object.keys(data.cloud_front).length > 0
    ) {
      videoPlayUrl = data.cloud_front.cloud_url;
      console.log(this.playUrlResObj);
      this.setCookie(
        "CloudFront-Key-Pair-Id",
        data.cloud_front.cloudfront_key_pair_id.trim(),
        1
      );
      this.setCookie(
        "CloudFront-Policy",
        data.cloud_front.cloudfront_policy.trim(),
        1
      );
      this.setCookie(
        "CloudFront-Signature",
        data.cloud_front.cloudfront_signature.trim(),
        1
      );
    } else {
      videoPlayUrl = playObj.preview_url;
    }

    ("http://j-cdr.digivive.com/HLS_Aaj/Aaj.m3u8");
    console.log(this.playUrlResObj);

    let title = '<div id="show_temp">' +
      '<span class="temp-seasnon movie_title">' + playObj.preview_title + '</span>' + '</div>';


    let advertisement_url = '';

    let new_source = {
      sources: [{ src: videoPlayUrl, type: "application/x-mpegURL" }],
      controls: true,
      autoplay: true,
      withCredentials: true,
      crossDomain: true,
      fluid: true,
      controlBar: {
        children: [
          // "playToggle",
          "volumeMenuButton",
          // "durationDisplay",
          // "timeDivider",
          // "currentTimeDisplay",
          "progressControl",
          // "remainingTimeDisplay",
          // "fullscreenToggle"
        ]
      },
    };

    this.playermodal = videojs("preview_video", new_source);
    console.log('this.playermodal', this.playermodal);
    // alert(this.playermodal.userActive());
    this.playermodal.userActive(false);
    var muted = this.playermodal.muted(true);
    this.playermodal.controlBar.progressControl.disable();




    videojs.options.hls.overrideNative = true;
    videojs.options.html5.nativeAudioTracks = false;
    videojs.options.html5.nativeTextTracks = false;
    google.ima.settings.setDisableCustomPlaybackForIOS10Plus(true);
    var startEvent = "click";
    if (
      navigator.userAgent.match(/iPhone/i) ||
      navigator.userAgent.match(/iPad/i) ||
      navigator.userAgent.match(/Android/i)
    ) {
      startEvent = "touchend";
    }
    let _this = this;
    this.playermodal.one(startEvent, function () {
      _this.playermodal.ima.initializeAdDisplayContainer();
    });
    // this.playermodal.poster(playObj.assetData.image);
    //https://www.nuevodevel.com/nuevo/doc
    this.playermodal.nuevo({
      videoInfo: true,
      infoTitle: title,
      infoIcon: "",
      qualityMenu: true,
      pipButton: false,
      settingButton: true,
      buttonRewind: true,
      buttonForward: true,
      resume: true,
      // poster: playObj.assetData.image,
      errordisplay: false,
      shareMenu: false,
      contextMenu: false,

    });




    $(".player_one-dimensions.vjs-fluid").css(
      "height",
      `${window.innerHeight}px`
    );

    $(window).bind("orientationchange", function (event) {
      let height = window.innerHeight;
      $(".player_one-dimensions.vjs-fluid").css("height", `${height}px`);
    });

    $(window).resize(function () {
      let height = window.innerHeight;
      $(".player_one-dimensions.vjs-fluid").css("height", `${height}px`);
    });

    this.playermodal.on("fullscreenchange", (event) => { });
    let newSelf = this;
    this.playermodal.on("nuevoReady", (event) => {
      event.preventDefault();

      let playingCode =
        data.recently_watched.code == undefined
          ? data.seek_bar_data.code
          : data.recently_watched.code;

      if (data.recently_watched.stop != undefined || data.is_trailer) {

        let preTime = Math.round(data.recently_watched.stop);
        var _this = this;
        if (advertisement_url == "") {
          this.playermodal.one("loadedmetadata", function () {
            console.log("setting current time to 60 seconds " + preTime);
            _this.playermodal.currentTime(preTime);
          });
        }

        this.playermodal.on("adend", function () {
          // 3. Re-enable volume, restart video from beginning
          console.log(playingCode + " == " + _this.currentPlayingCode);
          if (playingCode == _this.currentPlayingCode) {
            _this.playermodal.currentTime(preTime);
          } else {
            // alert('513')
            _this.playermodal.play();
          }
        });
        this.playermodal.on("complete", function (e) {
          console.log(e);
        });
        this.playermodal.on("adserror", function (e) {
          console.log(e);
        });
        // this.playermodal.on("mouseenter", function (e) {
        //   alert(78);
        // });
        // this.playermodal.on("mouseleave", function (e) {
        //   alert(1000);
        // });
        // this.playermodal.currentTime(preTime);
      }

      $(".vjs-text").append(
        '<i class="fa fa-arrow-left vjs-ttl_btn" id="vjs-ttl_btn"></i>'
      );

      // $(".uaRationOnPLayer").append(
      //   '<i class="vjs-ttl_btn" id="vjs-ttl_btn">UA 17</i>'
      // );


      let buttonfwd = document.getElementById("vjs-ttl_btn");

      buttonfwd.ontouchstart = (event) => {
        // this.stopVideo();
        event.stopPropagation();

        event.preventDefault();

        // this.disableModal();
        if (this.playermodal) this.playermodal.dispose();

        this.playermodal = "";

        return false;
      };

      buttonfwd.onclick = (event) => {
        console.log("buttonfwd.onclickdd");
        // this.stopVideo();
        event.stopPropagation();

        event.preventDefault();

        // this.disableModal();
        if (this.playermodal) this.playermodal.dispose();
        // alert('this.playermodal' +this.playermodal)
        //$('body').removeClass('vjs-full-window');
        this.playermodal = "";

        return false;
      };



      $("#next_button").css({
        background: "rgb(2 2 2 / 100%)",
        width: "130px",

        top: "50%",
        right: "1%",
        cursor: "pointer",
        "z-index": "3",
        position: "absolute",
        display: "none",
        padding: "0",
        border: "0",
        outline: "0 !important",
        "border-radius": "4px",

      });

      let nextbutton = document.getElementById("next_button");

      nextbutton.onclick = (event) => {
        event.stopPropagation();
        event.preventDefault();


      };

      nextbutton.ontouchstart = (event) => {
        event.stopPropagation();
        event.preventDefault();


      };



      $("#back_button").css({
        background: "rgb(35 36 37 / 64%)",
        width: "18%",
        top: "50%",
        "margin-top": "-2%",
        "margin-left": "1%",
        cursor: "pointer",
        "z-index": "3",
        position: "absolute",
        display: "none",
        padding: "0",
        border: "0",
        outline: "0 !important",
        "border-radius": "10px",
        transform: "translateY(-50%)",
      });

      let backbutton = document.getElementById("back_button");

      backbutton.onclick = (event) => {
        event.stopPropagation();
        event.preventDefault();


      };

      backbutton.ontouchstart = (event) => {
        event.stopPropagation();
        event.preventDefault();


      };

      // Skip intro button & Click Functionlity


    });

    // let self = this;
    let isPlaced: boolean = false;
    this.playermodal.on("timeupdate", () => {

      let currentPlayingTime = this.playermodal.currentTime();

      $("#next_button").css({ display: "none" });

      let totalDuration = Math.round(this.playermodal.duration());
      let playedDuration = Math.round(this.playermodal.currentTime());

      let playingDuration = (playedDuration * 100) / totalDuration;

    });

    this.playermodal.on("seeking", (event) => {

      if (this.playermodal.remainingTime() <= 31) {
        let remainingTime = Math.round(this.playermodal.remainingTime()) + 3 + 's ';
        $('.progress_move_background').css('animation-duration', remainingTime);
      }
    });
    let name = title;
    let type = data.type;
    let code = data.recently_watched.code;
    let action = 'Playing';
    this.playermodal.on("play", (event) => {
      $('.progress_move_background').removeClass("animation-paused");

      action = 'Playing';


    });

    this.playermodal.on("pause", (event) => {
      // $('.progress_move_background').css('animation-play-state', 'paused');
      $('.progress_move_background').addClass("animation-paused");

      action = 'Paused';
    });
    this.playermodal.on("fullWindowOnEscKey", (event) => { });

    this.playermodal.on("ended", (event) => {
      console.log("ended");
      this.checkOldPlayer();
      this.is_preview = false;

      action = 'Stopped';
    });
    this.playermodal.on("dispose", (event) => {

    });
    this.playermodal.on("error", (event) => {
      console.error(event);
    });

  }

  playvideoRecomnd(data, play_episode) {
    localStorage.setItem('is_check_device', 'true');
    this.checkOldPlayer();
    // this.disableScrollBar();
    this.playEpisodeData = data;
    this.playEpisodeData['plan'] = this.isPlan;

    this.playEpisodeData['recently_watched'] = {};
    this.playEpisodeData['recently_watched']['show_id'] = data.show_id;
    this.playEpisodeData['recently_watched']['season_id'] = data.season_id;
    this.playEpisodeData['recently_watched']['stop'] = data.seek_bar_data.stop;
    this.playEpisodeData['recently_watched']['duration'] = data.seek_bar_data.duration;

    if (((data.seek_bar_data.stop * 100) / data.seek_bar_data.duration) >= 98) {
      this.playEpisodeData['recently_watched']['stop'] = 0;
    }



    this.playEpisodeData['recently_watched']['asset_mongo_id'] = this.playEpisodeData.asset_mongo_id;
    this.playEpisodeData['recently_watched']['charge_code'] = this.playEpisodeData.charge_code;
    this.playEpisodeData['recently_watched']['content_availability'] = this.playEpisodeData.content_availability;

    this.playEpisodeData['recently_watched']['thumbnail'] = this.playEpisodeData.thumbnail;
    this.playEpisodeData['recently_watched']['sec'] = this.playEpisodeData.sec;
    this.playEpisodeData['recently_watched']['min'] = this.playEpisodeData.min;
    this.playEpisodeData['recently_watched']['hours'] = this.playEpisodeData.hours;
    this.playEpisodeData['recently_watched']['genre_text'] = this.playEpisodeData.genre_text;
    // this.playEpisodeData['recently_watched']['genre'] = this.playEpisodeData.genre;
    this.playEpisodeData['recently_watched']['languages'] = this.playEpisodeData.languages;
    this.playEpisodeData['recently_watched']['synopsis'] = this.playEpisodeData.synopsis;
    this.playEpisodeData['recently_watched']['code'] = this.playEpisodeData.code;
    //this.playEpisodeData['seasons'] = this.seasonData.result;

    if (data.type == 'episode' || data.type == 'tvshow') {
      this.playEpisodeData['totalSeason'] = Object.keys(this.totalSeason).length;
      if (this.playEpisodeData.content_availability.toLowerCase() != 'free' && this.playEpisodeData.is_pack_active != 1) {
        // this.router.navigate(['subscribe/choseplan'], { queryParams: { 'code': this.playEpisodeData.code } });
        this.router.navigate(['subscribe/choseplan']);
      } else {
        this.disableScrollBar();
        this.modalService.open(play_episode, { ariaLabelledBy: 'modal-basic-title', windowClass: '_play_modal_jw jwfullscreen', size: 'xl', backdrop: 'static' }).result.then((result) => {
        }, (reason) => {
        });

      }
    }

    else {
      data.name = data.name.toString().toLowerCase()
        .replace(/\s+/g, '-')           // Replace spaces with -
        .replace(/[^\w\-]+/g, '')       // Remove all non-word chars
        .replace(/\-\-+/g, '-')         // Replace multiple - with single -
        .replace(/^-+/, '')             // Trim - from start of text
        .replace(/-+$/, '');

      this.commonService.goToDetail(data);
    }
  }
  playTrailerFromList(index, play_episode) {
    localStorage.setItem('is_check_device', 'false');
    this.checkOldPlayer();
    this.disableScrollBar();
    // data.is_trailer = 1;
    this.playEpisodeData = this.episodeDeatil;
    this.playEpisodeData.is_trailer_list_index = index;
    this.playEpisodeData.is_trailer = 1;

    if (((this.episodeDeatil.recently_watched.stop * 100) / this.episodeDeatil.recently_watched.duration) >= 98) {
      this.playEpisodeData['recently_watched']['stop'] = 0;
    }

    if (this.episodeDeatil.type == 'movie' || this.episodeDeatil.type == 'tvshow' || this.episodeDeatil.type == 'vod' || this.episodeDeatil.type == 'event') {

      this.modalService.open(play_episode, { ariaLabelledBy: 'modal-basic-title', windowClass: '_play_modal_jw jwfullscreen', size: 'xl', backdrop: 'static' }).result.then((result) => {
      }, (reason) => {
      });


      let userUnique = '';
      if (this.userInfo.result.register_by == "mobile") {
        userUnique = this.userInfo.result.mobile;
      }
      else {
        userUnique = this.userInfo.result.emailaddress;
      }

      this.googleEvent.eventEmitter('Trailer', 'Video_view', this.episodeDeatil.name + '-' + this.episodeDeatil.code + '-' + userUnique, 0, userUnique, this.episodeDeatil.name + '-' + this.episodeDeatil.code + '-' + userUnique);

    }

    else {
      this.episodeDeatil.name = this.episodeDeatil.name.toString().toLowerCase()
        .replace(/\s+/g, '-')           // Replace spaces with -
        .replace(/[^\w\-]+/g, '')       // Remove all non-word chars
        .replace(/\-\-+/g, '-')         // Replace multiple - with single -
        .replace(/^-+/, '')             // Trim - from start of text
        .replace(/-+$/, '');

      this.commonService.goToDetail(this.episodeDeatil);
    }


  }


  detailPageRedirect(recommedDetail) {
    this.copyLink = false;
    document.getElementById("nexg_ngb-progressbar").style.display = 'block';
    document.getElementById('maincontentarea').classList.add("_beforeLoad");

    this.liniarProgressBar();
    window.scrollTo(0, 0);
    let assetDetail = {
      code: recommedDetail.code,
      type: recommedDetail.type ? recommedDetail.type : ''
    }

    recommedDetail.name = recommedDetail.name.toString().toLowerCase()
      .replace(/\s+/g, '-')           // Replace spaces with -
      .replace(/[^\w\-]+/g, '')       // Remove all non-word chars
      .replace(/\-\-+/g, '-')         // Replace multiple - with single -
      .replace(/^-+/, '')             // Trim - from start of text
      .replace(/-+$/, '');

    this.commonService.goToDetail(recommedDetail, 'Screen_Detail_Similar', 1);
    document.body.scrollTop = 0;
    this.readmoreCond = false;
    this.readMoreText = 'View More'

  }

  recomData(recommededParams) {

    setTimeout(() => {
      this.spinner.hide();
    }, 50);
    this.loading = true;
    let urlEncodedRecomdedParams = this.UserService.convertoJSONToUrlEncoded(recommededParams);
    this.AssetsService.getRecommended(urlEncodedRecomdedParams).subscribe(data => {
      console.log('recommendedData', data);
      this.recommendedData = data;
      if (this.recommendedData.result && this.recommendedData.result.length > 0) {
        this.getWatchList();
        this.recommendedData.result.forEach(ele => {
          if (ele.type == "episode") {
            if (!this.episodeArr.find(epiObj => epiObj.name == ele.ss)) {
              this.episodeArr.push({ name: ele.ss })
            }
            this.firstSelectedEpisode = this.episodeArr[0].name;
          }


        });
      }

    });

  }
  readMore() {
    this.readMoreText = this.readMoreText == "View More" ? "Read Less" : "View More";
    this.readmoreCond = this.readmoreCond ? false : true;
  }

  get season() {
    return '';
  }


  AddToWatchList(e, item, from = 'headerOnDetailPage') {
    console.log(e);
    e.stopPropagation();
    this.deleteFrom = from;
    console.log(item);
    this.addWachlistItemFromDetail = item;


    if (Object.keys(this.userInfo.result).length > 0) {

      let userUnique = '';
      if (this.userInfo.result.register_by == "mobile") {
        userUnique = this.userInfo.result.mobile;
      } else {
        userUnique = this.userInfo.result.emailaddress;
      }

      this.googleEvent.eventEmitter("Watchlist", "Watchlist", userUnique + '-' + item.code + '-' + item.name, 0, userUnique, userUnique + '-' + item.code + '-' + item.name);
    }


    let addToplayListParams = {
      playlistid: this.playListId ? this.playListId : '',
      catlogue: CatlougeTypeConstants.catlogue,
      plateform: "web",
      playingtype: "Video",
      assetId: item.asset_mongo_id ? item.asset_mongo_id : item._id,
      assetType: item.type ? item.type : '',
      action: "saveAssetInPlaylist",
    }


    if (from != 'headerOnDetailPage') {
      this.addedAssetIndexFromRecommended = this.recommendedData.result.findIndex(d => d['code'] == item.code)
      this.recommendedData.result[this.addedAssetIndexFromRecommended]['is_watchlist_added'] = true;

    }
    let urlEncodedToplayListParams = this.UserService.convertoJSONToUrlEncoded(addToplayListParams);
    if ((item.asset_mongo_id ? item.asset_mongo_id : item._id) != undefined) {

      this.playListService.addToPlayList(urlEncodedToplayListParams).subscribe((data) => {
        this.error_code = data.error_code;
        this.addToWatchListSuccessFromDetail.nativeElement.click();
        if (data.error_code == '200') {
          this.episodeDeatil.is_watchlist_added = true;
        }

        if (data.error_code == '209') {
          if (this.deleteFrom == 'headerOnDetailPage') {
            this.episodeDeatil.is_watchlist_added = false;
          } else {
            this.recommendedData.result[this.addedAssetIndexFromRecommended]['is_watchlist_added'] = false;
          }
          this.deleteWatchListItem(item);
        }
        setTimeout(() => {
          document.getElementById('removeToWatchListSuccessModal').click();
        }, 1500);
      });
    } else {
    }
  }

  gotoChoosePlan() {

    if (this.episodeDeatil.recently_watched != undefined) {
      this.router.navigate(['subscribe/choseplan'], { queryParams: { 'code': this.episodeDeatil.recently_watched.code } });
    } else {
      this.router.navigate(['subscribe/choseplan'], { queryParams: { 'code': this.episodeDeatil.code } });
    }

  }

  expendEpisodeSynopsis(i) {
    this.episodeIndex = i
  }

  strToLower(str: string) {
    if (str)
      return str.toLowerCase();
    else
      return str;
  }


  secondsToHms(d) {
    d = Number(d);
    var h = Math.floor(d / 3600);
    var m = Math.floor(d % 3600 / 60);
    var s = Math.floor(d % 3600 % 60);

    var hDisplay = h > 0 ? h + (h == 1 ? "h " : "h ") : "";
    var mDisplay = m > 0 ? m + (m == 1 ? "m " : "m ") : "";
    var sDisplay = s > 0 ? s + (s == 1 ? "s " : "s ") : "";

    if (hDisplay != '') {
      return hDisplay + mDisplay;
    } else {
      return mDisplay + sDisplay;
    }
  }


  deleteWatchListItem(item) {
    console.log(item);

    this.deleteAsset_id = item.asset_mongo_id ? item.asset_mongo_id : item._id;

    let deletePlayListAssets = {
      playlistid: this.playListId,
      assetId: this.deleteAsset_id,
      catlogue: CatlougeTypeConstants.catlogue,
      plateform: "web",
      // playlist_asset_id:item._id,
      action: "deleteAssetFromPlaylist"
    }

    let urlEncodedToplayListParams = this.UserService.convertoJSONToUrlEncoded(deletePlayListAssets);
    this.playListService.deleteFromPlayList(urlEncodedToplayListParams).subscribe((data) => {
    });

  }

  check_into_watchlist() {
    this.recommendedData.result.forEach((assetsObj, index) => {
      if (this.playlist.findIndex(tempObj => tempObj._id == assetsObj._id) != -1) {
        this.recommendedData.result[index].is_watchlist_added = true;
      } else {
        this.recommendedData.result[index].is_watchlist_added = false;
      }
    });
  }

  checkEpisodeIntoWatchList() {
    console.log(this.episodeDeatil);
    if (this.playlist.findIndex(tempObj => tempObj.code == this.episodeDeatil.code) != -1) {
      this.episodeDeatil.is_watchlist_added = true
    } else {
      this.episodeDeatil.is_watchlist_added = false;
    }
  }

  getWatchList() {

    this.playListId = localStorage.getItem('playListId');
    let temp = {
      playlistid: this.playListId ? this.playListId : '',
      catlogue: CatlougeTypeConstants.catlogue,
      plateform: "web",
      action: "getPlayListAsset",
    }

    let urlEncodedPlayListAssetsParams = this.UserService.convertoJSONToUrlEncoded(temp);
    this.playListService.getPlaylist(urlEncodedPlayListAssetsParams).subscribe(data => {
      if (data && data.result && Array.isArray(data.result)) {
        if (Array.isArray(data.result)) {
          this.playListAvailable = true;
          this.playlist = data.result;
          console.log(this.playlist);
          this.check_into_watchlist();
          this.checkEpisodeIntoWatchList();
          return this.playlist;
        }
      }
    });

  }


  disableScrollBar() {
    document.getElementById('nexgTV-app').style.overflow = "hidden !important;"
    $("body").css("overflow-y", "hidden");
  }

  enableScrollBar() {
    document.getElementById('nexgTV-app').style.overflow = "visible !important;"
    window.scrollTo(0, 0);
    // document.body.scrollTop = 0;
  }

  liniarProgressBar() {
    // progress bar code
    this.progrssBarValue = 0;
    this.progressInc = 0;
    let progrssInterval = setInterval(() => {
      this.progrssBarValue = this.progressInc * 10;

      if (this.progressInc >= 10) {
        clearInterval(progrssInterval);
      }
      this.progressInc++;
      console.log(this.progrssBarValue);
    }, 500)

  }



  isEmptyObject(obj) {
    return (obj && (Object.keys(obj).length === 0));
  }

  muteUnmutePreview(is_muted) {
    if (is_muted) {
      this.is_muted = false;
      var muted = this.playermodal.muted(false);
    } else {
      this.is_muted = true;
      var muted = this.playermodal.muted(true);
    }

    console.log(muted);
    console.log(this.playermodal);

  }

  setCookie(cname, cvalue, exdays) {
    var d = new Date();
    d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
    var expires = "expires=" + d.toUTCString();
    document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
  }



}
